import { productTypeMapHelpers } from 'views/custom-declaration/products/productTemplateMap';
import { ValidationSchema, withoutRequiredValidators } from 'views/declarations/uk/export/validations/validations';

// Same format validation as the product template of the declaration type, minus the required rules:
// an item field template may leave any field empty.
const getItemFieldTemplateValidation = (
    country?: string,
    internalType?: string,
    type?: string
): ValidationSchema | undefined => {
    if (!country || !internalType || !type) return undefined;

    const typeMap =
        productTypeMapHelpers[country.toLowerCase()]?.[internalType as keyof typeof productTypeMapHelpers.uk];
    const typeParams = { ...typeMap?.default, ...typeMap?.[type] };

    return withoutRequiredValidators(typeParams.validate) as ValidationSchema | undefined;
};

export default getItemFieldTemplateValidation;
